"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function CardHeader({ children, className, exdent, level, ...props }) {
    // eslint-disable-next-line no-nested-ternary
    const Heading = level === 3 ? 'h3' : level === 4 ? 'h4' : 'h2';
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-card__header', exdent && 'usa-card__header--exdent', className), ...props, children: (0, jsx_runtime_1.jsx)(Heading, { className: "usa-card__heading", children: children }) }));
}
exports.default = CardHeader;
